import React, { PropsWithChildren } from 'react';
import { Box } from '@material-ui/core';
import { MDSTheme, MDSTypography } from '@marqvision/mds/core';
import { CheckFillIcon, ErrorWarningFillIcon, InfoBorderIcon } from '@marqvision/mds/icons';
import { useBreakpoint } from '~/hooks';

const NoticeText = ({
  children,
  variant,
  textVariant,
  textStyle,
}: PropsWithChildren<{
  variant?: 'alert' | 'success';
  textVariant?: any;
  textStyle?: React.CSSProperties;
}>): JSX.Element => {
  const getColor = () => {
    switch (variant) {
      case 'alert':
        return MDSTheme.palette.red[700];
      case 'success':
        return MDSTheme.palette.green[700];
      default:
        MDSTheme.palette.bluegray[800];
    }
  };

  const color = getColor();
  const { getMediaQueryValue: mq } = useBreakpoint();

  const variantIcon = {
    success: <CheckFillIcon color={color} />,
    alert: <ErrorWarningFillIcon />,
    default: <InfoBorderIcon scale={0.8333} color={color} />,
  };

  return (
    <Box marginTop="5px" display="flex" alignItems="center">
      <span style={{ flexShrink: 0, paddingTop: '3px' }}>{variantIcon[variant || 'default']}</span>
      <MDSTypography
        variant={textVariant || mq('T14', 'T16', 'T16')}
        weight="medium"
        style={{ marginLeft: '4px', color, ...textStyle }}
      >
        {children}
      </MDSTypography>
    </Box>
  );
};

export default NoticeText;
